// extracted by mini-css-extract-plugin
export var clamp = "SameEventMultiOutcome-module--clamp--6bec7";
export var container = "SameEventMultiOutcome-module--container--99efc";
export var icon = "SameEventMultiOutcome-module--icon--ca038";
export var isVoid = "SameEventMultiOutcome-module--isVoid--3ae15";
export var isWon = "SameEventMultiOutcome-module--isWon--da7e0";
export var marketName = "SameEventMultiOutcome-module--marketName--c4b1f";
export var outcome = "SameEventMultiOutcome-module--outcome--77c2a";
export var outcomeAndMarket = "SameEventMultiOutcome-module--outcomeAndMarket--9c597";
export var outcomeName = "SameEventMultiOutcome-module--outcomeName--55568";
export var pickIcon = "SameEventMultiOutcome-module--pickIcon--d97d5";
export var statusIcon = "SameEventMultiOutcome-module--statusIcon--fca83";